import dynamic from "next/dynamic";

export const NumberedList = dynamic(() => import("./component"));
